import { FaFacebook, FaInstagram } from "react-icons/fa";
import "./ContactSection.css";

export default function ContactSection() {
  return (
    <section id="section7" className="contact-section">
      <div className="contact-container">
        <h2>CONTACT US</h2>

        <div className="contact-info">
          <p>
            <strong>IOANNA PAPAIOANNOU</strong>
            <br />
            +30 6945360017
          </p>
          <p>
            <strong>EVANGELOS NTOMOPOULOS</strong>
            <br />
            +30 6986512414
          </p>
          <p>
            <strong>Email:</strong>
            <br />
            athensuncorked25@gmail.com
          </p>
          
          <div className="socials-row">
            <div className="socials-container">
              <p className="social-title">SOCIAL</p>
              <div className="socials">
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebook />
                </a>
                <a
                  href="https://www.instagram.com/athens_uncorked?igsh=emhxdzF0cGxraXY0"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
              </div>
            </div>
            
            <div className="volunteer-btn-container">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSecvj6B6gKZpge9Al-Kq9XiedhNpSQ7xKFzn5zpNff8VRuoLg/viewform" target="_blank" rel="noopener noreferrer" className="volunteer-btn">
                Become a Volunteer
              </a>
            </div>
          </div>
        </div>
      </div>
            <div className="creator-credit">
        <p>
          Created by{" "}
          <a 
            href="https://intechnio.wordpress.com/creating/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Pas'
          </a>
        </p>
      </div>
    </section>
    
  );
}